function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.for-each.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.some.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.string.starts-with.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.define-property.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.object.define-properties.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import NestedDashboardOptionsEditor from './nestedDashboardOptionsEditor.vue';
export default {
  name: 'ActionParametersEditDialog',
  components: {
    NestedDashboardOptionsEditor: NestedDashboardOptionsEditor
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    action: {
      type: Object,
      required: true
    },
    parameterDefinitions: {
      type: Array,
      required: true
    },
    dashboardId: {
      type: String,
      required: true
    },
    customParameters: {
      type: Object,
      required: false,
      "default": function _default() {}
    }
  },
  data: function data() {
    return {
      temporaryActionParameters: {}
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['color', 'inpOutlined', 'inpFilled'])), mapState('dashboards', ['dashboards'])), {}, {
    dashboard: function dashboard() {
      return this.dashboards[this.dashboardId];
    },
    show: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    },
    visibleParameterDefinitions: function visibleParameterDefinitions() {
      return this.parameterDefinitions.filter(this.evaluateParameterIfCondition);
    }
  }),
  watch: {
    show: function show(value) {
      if (value) {
        this.temporaryActionParameters = {};
      }
    },
    parameterDefinitions: {
      handler: function handler(newDefinitions) {
        var _this = this;
        var clone = cloneDeep(this.temporaryActionParameters);
        newDefinitions.forEach(function (parameter) {
          if (clone[parameter.key] !== undefined) {
            return;
          }
          if (_this.action.parameters[parameter.key] !== undefined) {
            clone[parameter.key] = _this.action.parameters[parameter.key];
          }
          if (clone[parameter.key] === undefined) {
            clone[parameter.key] = parameter["default"];
          }
        });
        Object.keys(clone).forEach(function (key) {
          if (!newDefinitions.some(function (p) {
            return p.key === key;
          })) {
            delete clone[key];
          }
        });
        this.temporaryActionParameters = clone;
      }
    }
  },
  methods: {
    parseInputValue: function parseInputValue(type, value) {
      if (type === 'number') {
        return Number(value);
      }
      return value;
    },
    updateActionParameter: function updateActionParameter(key, type, value) {
      var clone = cloneDeep(this.temporaryActionParameters);
      clone[key] = this.parseInputValue(type, value);
      this.temporaryActionParameters = clone;
    },
    saveActionParameters: function saveActionParameters() {
      if (!this.$refs.form.validate()) {
        return;
      }
      var combinedParameters = _objectSpread(_objectSpread({}, this.action.parameters), this.temporaryActionParameters);
      this.$emit('update:parameters', combinedParameters);
    },
    evaluateParameterIfCondition: function evaluateParameterIfCondition(parameter) {
      if (!parameter["if"]) {
        return true;
      }
      var condition = parameter["if"];
      var invert = false;
      if (condition.startsWith('!')) {
        invert = true;
        condition = condition.substring(1);
      }
      var value = get(this.temporaryActionParameters, condition);
      return invert ? !value : !!value;
    }
  }
};